import { createFileRoute } from "@tanstack/react-router";

import Error404 from "/src/routes/errors/serverError/Error404";

export const Route = createFileRoute("/_main/$")({
  component: Error404,
});
